import '../packages/hofmeister/Resources/Public/JavaScript/main.js'
import '../packages/hofmeister/Resources/Public/JavaScript/klaro_config.js'
import '../node_modules/klaro/dist/klaro-no-css.js'
import '../packages/hofmeister/Resources/Public/Scss/main.scss'

window.klaro = klaro;
